import React, { useEffect } from "react";
import ProjectDescription from '../components/ProjectDescription';
import { Helmet } from "react-helmet";
import { Container, Row, Col } from 'react-grid-system';
import  ProjectModel from '../models/ProjectModel';
import ProjectIndex from '../components/ProjectIndex';
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import '../App.css';

function Atlantic({dispatch}) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  return (
<div className="wrapper">

	<Helmet>
		<meta charSet="utf-8" />
		<title>Maria Chimishkyan — {ProjectModel.Atlantic.title}</title>
	</Helmet>

	<div className="inner-wrapper">
		<Container fluid className="page-pad">
			<Row>
				<Col sm={3}>
					<div className="description-sticky">
					  <ProjectDescription projectModel={ProjectModel.Atlantic}/>
					</div>
				</Col>
				<Col sm={6}>
					<img src="img/project-page/the-atlantic/theatlantic-MariaChimishkyan-0.gif" alt="The Atlantic — Maria Chimishkyan 0" style={{ width: '100%' }}/>
					<div className="cs-section-sep">
					<div className="cs-half-images">
						<div>
							<video className="reg" loop autoPlay muted playsInline style={{ objectFit: 'contain', width: '100%' }}
							src="img/project-page/the-atlantic/theatlantic-MariaChimishkyan-1.mp4"
							alt="The Atlantic - Maria Chimishkyan 1"/>
							<div className="project-caption">Best Music of 2021</div>
						</div>
						<div>
							<video className="reg" loop autoPlay muted playsInline style={{ objectFit: 'contain', width: '100%' }}
							src="img/project-page/the-atlantic/theatlantic-MariaChimishkyan-3.mp4"
							alt="The Atlantic - Maria Chimishkyan 3"/>
							<div className="project-caption">Best Films of 2021</div>
						</div>
					</div>
					</div>
					<div className="cs-section-sep">
					<div className="cs-half-images">
						<div>
							<video className="reg" loop autoPlay muted playsInline style={{ objectFit: 'contain', width: '100%' }}
							src="img/project-page/the-atlantic/theatlantic-MariaChimishkyan-2.mp4"
							alt="The Atlantic - Maria Chimishkyan 2"/>
							<div className="project-caption">Best Books of 2021</div>
						</div>
						<div>
							<video className="reg" loop autoPlay muted playsInline style={{ objectFit: 'contain', width: '100%' }}
							src="img/project-page/the-atlantic/theatlantic-MariaChimishkyan-4.mp4"
							alt="The Atlantic - Maria Chimishkyan 4"/>
							<div className="project-caption">Best Podcasts of 2021</div>
						</div>
					</div>
					</div>
				</Col>
			</Row>
		</Container>
	</div>
	<ProjectIndex/>
</div>

  )
}

export default connect()(Atlantic);
